import {
  BusinessListElement,
  BusinessListElementBusinessType,
} from "../../../components/businessListElement/BusinessListElement";
import { ParentLink } from "../../../components/navigation/ParentLink";
import { DIRECT_MESSAGE } from "../../../constants/routes";

export const NewConnectionCommentLink = ({
  relationshipId,
  setActive,
  business,
}: {
  setActive: (active: boolean) => void;
  relationshipId: number;
  business: BusinessListElementBusinessType;
}) => {
  return (
    <>
      <ParentLink
        key={relationshipId}
        to={DIRECT_MESSAGE.href({ relationshipId })}
      >
        <BusinessListElement
          text={"Message"}
          business={business}
          onClick={() => {
            setActive(false);
          }}
        />
      </ParentLink>
    </>
  );
};
